export default function getInitState() {
    return {
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            },
            per_page: 10,
        },
        headerFields: [
            {
                name: "version",
                label: "Verzió",
                visibility: true,
                slot_name: "version_format",
            },
            {
                name: "createdOn",
                label: "Kelt",
                visibility: true,
                slot_name: "datetime_format",
            },
            {
                name: "actionText",
                label: "Esemény",
                visibility: true,
                slot_name: "action_text_format",
            },
            {
                name: "validatedOn",
                label: "Validálás dátuma",
                visibility: true,
                slot_name: "history_validatedOn",
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
    }
}
